import React from 'react';
import Icon from './icon';
import { Text, View } from 'react-native';

export const IcoLogo = Icon('logo');
export const IcoFosol = Icon('fosol_en', 'fosol_ar');
export const IcoFosolLogo = Icon('fosol_en_logo', 'fosol_ar_logo');
export const IcoBack = Icon('ios-previous', 'ios-next');
export const IcoNext = Icon('ios-next', 'ios-previous');
export const IcoPM = Icon('ema-email');
export const IcoSend = Icon('send');
export const IcoGroup = Icon('use-user-user-user');
export const IcoSettings = Icon('gen-cog');
export const IcoAccount = Icon('ios-contact');
export const IcoSupport = Icon('tel-headset');
export const IcoSuggestions = Icon('gen-light-bulb-on');
export const IcoLogout = Icon('ui-signout');
export const IcoClose = Icon('ui-cross');
export const IcoChat = Icon('cha-round-conversation');
export const IcoMaterial = Icon('doc-box');
export const IcoAnnouncements = Icon('doc-tasks');
export const IcoInfo = Icon('gen-information');
export const IcoSucess = Icon('ui-tick-2');
export const IcoTrash = Icon('ios-trash');
export const IcoPlus = Icon('cha-plus');
export const IcoDevices = Icon('tel-phone-mac');
export const IcoEdit = Icon('des-pencil');
export const IcoActionMenu = Icon('ios-morev');
export const IcoDownload = Icon('ios-download');
export const IcoDoc = Icon('doc-document');
export const IcoWatch = Icon('pho-redeye');
export const IcoDue = Icon('ios-stop-watch');
export const IcoSubmit = Icon('doc-filing');
export const IcoSubmits = Icon('doc-filing-2');
export const IcoCalendar = Icon('tim-calendar');
export const IcoTime = Icon('ios-recents');
export const IcoVoiceNote = Icon('mus-radio-mic');
export const IcoComposeActions = Icon('plus-symbol');
export const IcoCamera = Icon('pho-camera');
export const IcoGallery = Icon('pho-landscape');
export const IcoPolls = Icon('pre-bar-chartv');
export const IcoLocation = Icon('loc-point');
export const IcoCancel = Icon('ui-cross-2');
export const IcoDone = Icon('check-mark');
export const IcoDown = Icon('ios-down');
export const IcoUp = Icon('ios-up');
export const IcoPin = Icon('gen-paperclip');
export const IcoTarget = Icon('lay-path-circle2');
export const IcoPhone = Icon('tel-phone');
export const IcoMute = Icon('mus-mute');
export const IcoCode = Icon('doc-clipboard');
export const IconAndroid = Icon('bra-android');
export const IconIos = Icon('bra-apple');
export const IconComputer = Icon('com-mac');
export const IconDeleted = Icon('ui-cross-2');
export const IcoGroups = Icon('tel-headset-generic');
export const IcoHome = Icon('gen-home');
export const IcoCall = Icon('tel-fixed-handset');
export const IcoCopy = Icon('doc-documents');
export const IcoLanguage = Icon('spa-earth');
export const IcoAdmin = Icon('police-badge');
export const IcoStatus = Icon('lay-path-circle');
export const IcoId = Icon('sec-id');
export const IcoBlock = Icon('ui-block');
export const IcoPlay = Icon('mus-play');

const File = Icon('doc-document2');
export const IcoFileType = ({ ext, name, size }) => {
  const icon_size = size || 36;
  ext = ext
    ? ext.toLowerCase()
    : name
        .split('.')
        .pop()
        .toLowerCase();
  const files = {
    mp4: { color: '#FC8D3A', name: 'mp4' },
    avi: { color: '#FC8D3A', name: 'avi' },
    png: { color: '#408693', name: 'png' },
    jpg: { color: '#408693', name: 'jpg' },
    pdf: { color: '#BB3431', name: 'pdf' },
    xls: { color: '#3C744C', name: 'xls' },
    xlsx: { color: '#3C744C', name: 'xlsx' },
    ppt: { color: '#BE5139', name: 'ppt' },
    pptx: { color: '#BE5139', name: 'pptx' },
    txt: { color: '#89C1F7', name: 'txt' },
    rtfd: { color: '#89C1F7', name: 'rtf' },
    doc: { color: '#335593', name: 'doc' },
    docx: { color: '#335593', name: 'docx' }
  };
  const bg_color = files[ext] ? files[ext].color : '#999';
  ext = files[ext] ? files[ext].name : ext;

  return (
    <View style={{ alignItems: 'center' }}>
      <Text
        style={{
          position: 'absolute',
          color: 'white',
          top: icon_size / 2,
          fontSize: icon_size / 4,
          zIndex: 1,
          backgroundColor: bg_color
        }}
      >
        {ext.substring(0, 4)}
      </Text>
      <File color={bg_color} size={icon_size} />
    </View>
  );
};



// WEBPACK FOOTER //
// ./src/utils/icons/index.js